// extracted by mini-css-extract-plugin
export default {"icons":"DeleteAndUpdate_icons__LHbaA"};